// Copyright (c) 2022 by Move Closer

import { ModuleSize } from '@movecloser/page-builder/lib/contracts'

import { ModuleBase, ModuleFactory } from '../../contexts'

import { abstractModuleFactory, getDefaultModuleAlignment } from '../abstract/form'
import { AvailableModuleDriver } from '../allowed'

import { FooterModule, FooterModuleContent } from './Footer.contracts'
import { FooterModuleVersion } from './Footer.config'

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export const footerContentFactory = (): FooterModuleContent => ({
  authorSiteLink: undefined,
  badge: undefined,
  badgeType: undefined,
  badgeLink: undefined,
  brandImage: undefined,
  contactNav: undefined,
  deliveryNav: undefined,
  description: undefined,
  mainNav: undefined,
  logoLink: undefined,
  paymentNav: undefined,
  secondaryNav: undefined,
  socialNav: undefined
})

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export const footerFactory: ModuleFactory<FooterModule> = {
  ...abstractModuleFactory,
  createInitialSize (): ModuleSize {
    return {
      colSpan: 12,
      isResizable: false,
      rowSpan: 3
    }
  },
  createModule (): ModuleBase<FooterModule> {
    return {
      alignment: getDefaultModuleAlignment(),
      content: footerContentFactory(),
      driver: AvailableModuleDriver.Footer,
      version: FooterModuleVersion.Default
    }
  }
}
